module.exports = " <div class=products-category> <div class=products-category__header v-if=items.length> <h2 class=products-category__title>{{content.Name}}</h2> </div> <div class=products-category__content v-if=items.length> <ul class=product-list> <products-list-item v-for=\"item in items\" :category=content.Id :product=item track-by=$index></products-list-item> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/products/ProductsListCategory.vue
// module id = 204
// module chunks = 0